import React from 'react'
import PropTypes from 'prop-types'

const defaultStyle = { width: 36, height: 36 }
const smStyle = { width: 24, height: 24 }
const lgStyle = { width: 64, height: 64 }

export default class Icon extends React.PureComponent {
  static propTypes = {
    icon: PropTypes.string,
    lg: PropTypes.bool,
    style: PropTypes.object,
    sm: PropTypes.bool,
  }

  render() {
    const { icon, lg, sm, style, ...rest } = this.props

    let baseStyle = defaultStyle
    if (sm) {
      baseStyle = smStyle
    }
    if (lg) {
      baseStyle = lgStyle
    }
    const iconStyle = style ? { ...baseStyle, ...style } : baseStyle

    return <sprite {...rest} image={icon} style={iconStyle} />
  }
}
